import { DATE_UNIT, DateUtils } from "shared/dateUtils";
import { notifyError } from "../../../redux/actions/notificacaoActions";
import FazendaService from "../../../services/FazendaService";
import BalancoArrobaService from "../balancoArrobaService";
import {
  exibirCarregando,
  exibirModalFaltaDataInicial,
  exibirModalPesagensInsuficientes,
  listarDatasPesagem,
  obterDadosPeriodoBalanco,
} from "./balancoArrobaActions";

export const obterDatas = () => async (dispatch, getState) => {
  dispatch(exibirCarregando(true));
  try {
    const { fazenda } = getState();
    const fazendaTemDataInicioConciliacao =
      await checaSeFazendaTemDataInicioConciliacao(fazenda.FazendaSelecionada);

    if (!fazendaTemDataInicioConciliacao) {
      dispatch(exibirModalFaltaDataInicial(true));
      return;
    }

    const obtemDatasPesagem = await BalancoArrobaService.obterDatasPesagem(
      fazenda.FazendaSelecionada
    );
    const datasPesagem = obtemDatasPesagem.data.items;
    const datasAposConciliacao = datasPesagem
      .map((data) =>
        DateUtils.parse(data.DataPesagem).isSameOrAfter(
          fazenda.DataInicioConciliacao,
          DATE_UNIT.DAY
        )
          ? data
          : null
      )
      .filter((data) => data !== null);

    if (datasAposConciliacao.length < 2) {
      dispatch(exibirModalPesagensInsuficientes(true));
      return;
    }

    const ultimaDataPesagem =
      datasAposConciliacao[datasAposConciliacao.length - 1].DataPesagem;
    const penultimaDataPesagem =
      datasAposConciliacao[datasAposConciliacao.length - 2].DataPesagem;
    dispatch(listarDatasPesagem(datasAposConciliacao));
    dispatch(obterDadosBalanco(penultimaDataPesagem, ultimaDataPesagem));
  } catch (error) {
    const mensagemErro = {
      mensagem: "Ocorreu um erro ao obter o balanço de arroba da fazenda",
    };
    dispatch(notifyError(mensagemErro));
  } finally {
    dispatch(exibirCarregando(false));
  }
};

export const checaSeFazendaTemDataInicioConciliacao = async (idFazenda) => {
  try {
    const response = await FazendaService.checaDataConciliacao(idFazenda);
    return response.status === 200;
  } catch (error) {
    return false;
  }
};

export const desativaModalFaltaData = () => (dispatch) => {
  dispatch(exibirModalFaltaDataInicial(false));
};

export const obterDadosBalanco =
  (dataInicio, dataFim) => async (dispatch, getState) => {
    dispatch(exibirCarregando(true));
    try {
      const { fazenda } = getState();
      const balancosFazenda = await BalancoArrobaService.obterDadosBalanco(
        fazenda.FazendaSelecionada,
        dataInicio,
        dataFim
      );
      dispatch(obterDadosPeriodoBalanco(balancosFazenda.data));
    } catch (error) {
      const mensagemErro = {
        mensagem: "Ocorreu um erro ao obter o balanço de arroba da fazenda.",
      };
      dispatch(obterDadosPeriodoBalanco({}));
      dispatch(notifyError(mensagemErro));
    } finally {
      dispatch(exibirCarregando(false));
    }
  };
